import { render, staticRenderFns } from "./SpecialPacks.vue?vue&type=template&id=6ea3e186&scoped=true&"
import script from "./SpecialPacks.vue?vue&type=script&lang=js&"
export * from "./SpecialPacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea3e186",
  null
  
)

export default component.exports